<template>
  <main class="main-content" id="topDom">
    <section class="section">
      <ul class="breadcrumb">
        <li class="breadcrumb__li --current">
          <router-link to="/" class="breadcrumb__link">{{ $t("i18n.home") }}</router-link>
        </li>
        <li class="breadcrumb__li">
          <span class="breadcrumb__text"> {{ $t("i18n.vacuumValve") }}</span>
        </li>
      </ul>
     
      <div class="banner" style="cursor: pointer;" :style="{height: (isMobile() ? (windowHeight - 110) + 'px !important' : '61rem')}">
        <img class="mobileBg" v-if="isMobile()" :src="imageSrc" />
        <div class="banner__content container-fluid" v-if="!isMobile()">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 order-2 order-md-1">
              <h1 class="banner__title">{{ $t("i18n.vacuumValve") }}</h1>
            </div>
          </div>
        </div>
        <div class="banner__bg" v-if="!isMobile()">
          <img :src="imgPath" />
        </div>
      </div>

      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="outSwiperBox">
              <div id="swiper-pro">
                <div class="swiper-container pro-swiper inSwiperBox">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item,index) in $t('i18n.proList')" :key="index" @click="toPage(item)">
                      <div class="swiper-content swiper-content-select" >
                        <div class="swiper-pro-bottom">
                          <div class="swiper-pro-img">
                            <img class="swiper-lazy" :src="item.img" alt="轮播图">
                          </div>
                          <div class="swiper-pro-text">
                            {{ item.about }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 如果需要导航按钮 -->
                  <!-- <div class="swiper-button-prev pro-swiper-prev --pro"></div>
                  <div class="swiper-button-next pro-swiper-next --pro"></div> -->
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <div class="g-content">
            <div class="g-block-wrapper">
              <h2 style="font-size: 32px;">{{ $t('i18n.vacuumControlValveQa') }}</h2>
            </div>
            <div class="g-block-wrapper">
              <div class="accordion-wrapper">

                <div class="accordion-item" @click="showText(textList[0])" >
                  <div class="accordion-title">
                    {{ textList[0].title }}
                  </div>
                  <div class="accordion-content" :class="{ 'show-text': textList[0].show }">
                    {{ textList[0].text }}
                  </div>
                </div>
                <div class="accordion-item"  @click="showText(textList[1])" >
                  <div class="accordion-title">
                    {{ textList[1].title }}
                  </div>
                  <div class="accordion-content" :class="{ 'show-text': textList[1].show }">
                    {{ textList[1].text[0] }}
                    <br>
                    {{ textList[1].text[1] }}
                    <div class="accordion-wrapper">
                      <div class="g-block-wrapper">
                        <ul v-for="(child, indexS) of textList[1].children" :key="indexS">
                          <li>
                            {{ child.title }}
                            <div >
                              {{child.text}}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="accordion-item"  @click="showText(textList[2])" >
                  <div class="accordion-title">
                    {{ textList[2].title }}
                  </div>
                  <div class="accordion-content" :class="{ 'show-text': textList[2].show }">
                    {{ textList[2].text[0] }}
                    <br>
                    {{ textList[2].text[1] }}
                    <div class="accordion-wrapper">
                      <div class="g-block-wrapper">
                        <ul v-for="(child, indexS) of textList[2].children" :key="indexS">
                          <li v-html="child.title">

                          </li>
                        </ul>
                      </div>
                    </div>
                    <br>
                    {{ textList[2].text[2] }}
                    <br>
                    <br>
                    {{ textList[2].text[3] }}
                    {{ textList[2].text[4] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  </main>
</template>

<script>
import Swiper from "swiper";

export default {
  name: "VacuumValveMain",
  data() {
    return{
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
      list: [
        {
          name: "vacuumValve",
          path: "VacuumValveMain",
          isLast: true,
          showChild: false,
        },
        {
          name: "MGVAGV",
          path: "VacuumValve1",
          isLast: true,
          showChild: false,
          pathImg: require('../assets/imgs/MGVAGV.png'),
          img: require('../assets/imgs/MGVAGVimg.png'),
          technicalImg: require('../assets/imgs/MGVAGVTechnical.png'),
          downloadImg: require('../assets/imgs/MGVAGVDownloadImg.png'),
          propertiesName: "MGVAGVpro",
          showFlg: true,
          type: "PDF",
          size: "4 MB"
        },
        {
          name: "butterflyValve",
          path: "VacuumValve2",
          isLast: true,
          showChild: false,
          pathImg: require('../assets/imgs/butterfly.png'),
          img: require('../assets/imgs/butterflyImg.png'),
          technicalImg: require('../assets/imgs/butterflyTechnical.png'),
          downloadImg: require('../assets/imgs/butterfluDownloadImg.png'),
          propertiesName: "butterflyPro",
          showFlg: true,
          type: "PDF",
          size: "4 MB"
        },
        {
          name: "highVacuumDirectValve",
          path: "VacuumValve3",
          isLast: true,
          pathImg: require('../assets/imgs/corner.png'),
          img: require('../assets/imgs/corenrImgTwo.png'),
          technicalImg: require('../assets/imgs/corenrTechnicalOne.png'),
          downloadImg: require('../assets/imgs/corenrDownloadOne.png'),
          propertiesName: "highVacuumDirectValve",
          showFlg: true,
          type: "PDF",
          size: "4 MB"
        },
        {
          name: "UHV",
          path: "VacuumValve4",
          isLast: true,
          pathImg: require('../assets/imgs/corner.png'),
          img: require('../assets/imgs/corenrImg.png'),
          technicalImg: require('../assets/imgs/corenrTechnicalTwo.png'),
          downloadImg: require('../assets/imgs/corenrDownloadTwo.png'),
          propertiesName: "UHV",
          showFlg: true,
          type: "PDF",
          size: "4 MB"
        },
        {
          name: "rectangularValve",
          path: "VacuumValve5",
          showChild: false,
          isLast: true,

          pathImg: require('../assets/imgs/rectangularValve.png'),
          img: require('../assets/imgs/rectangularValveImg.png'),
          technicalImg: require('../assets/imgs/rectangularValveTechnical.png'),
          downloadImg: require('../assets/imgs/rectangularValveDownload.png'),
          propertiesName: "rectangularValve",
          showFlg: false,
          type: "PDF",
          size: "4 MB"
        },{
          name: "highVacuumGateValve",
          path: "VacuumValve6",
          isLast: true,

          pathImg: require('../assets/imgs/highVacuum.png'),
          img: require('../assets/imgs/highVacuumImg.png'),
          technicalImg: require('../assets/imgs/highVacuumTechnical.png'),
          downloadImg: require('../assets/imgs/highVacuumDownload.png'),
          propertiesName: "highVacuumGateValve",
          showFlg: true,
          type: "PDF",
          size: "4 MB"
        },
        {
          name: "vacuumGateValve",
          path: "VacuumValve7",
          isLast: true,

          pathImg: require('../assets/imgs/vacuum.png'),
          img: require('../assets/imgs/vacuumImg.png'),
          technicalImg: require('../assets/imgs/vacuumTechnical.png'),
          downloadImg: require('../assets/imgs/vacuumDownload.png'),
          propertiesName: "vacuumGateValve",
          showFlg: true,
          type: "PDF",
          size: "4 MB"
        },
        {
          name: "combinedValve",
          path: "VacuumValve8",
          isLast: false,
          pathImg: require('../assets/imgs/combinedValve.png'),
          img: require('../assets/imgs/combinedValveImg.png'),
          technicalImg: require('../assets/imgs/combinedValveTechnical.png'),
          downloadImg: require('../assets/imgs/combinedValveDownload.png'),
          propertiesName: "combinedValve",
          showFlg: true,
          type: "PDF",
          size: "4 MB"
        },
      ],
      textList: this.$t('i18n.vacuumControlValveQaList'),

      form: {},
      swiper: null,
      imgPath: this.isMobile() ? require("../assets/imgs/VacuumMainImg-P.png") : require("../assets/imgs/about-nei.png"),
      classS: {
        display: ""
      },
    }
  },
  created() {
    if (this.$store.state.language === "中文") {
      this.textList = [
        {
          title: "什么是真空阀?",
          text:
            "真空阀是一个安装在真空系统的供气或排气管道中的装置。\"它通常用于隔离真空区域，如工艺室，或控制进入和排出的气体量。真空阀可以手动、气动、电子气动、电动或电磁方式操作。真空阀是任何真空系统的一个组成部分，真空系统被广泛用于各种工业生产应用中。",
        },
        {
          title: "什么是高性能真空阀?",
          text: ["某些真空工艺对工艺环境的纯度以及化学和物理稳定性有特别高的要求。例如，这适用于几乎所有的半导体生产领域，以及许多使用真空系统的研究设施。在基础研究领域，处理极端条件的能力，如非常高或低的温度、强辐射和压力高达10-15mbar的极高真空(XHV)--目前技术上可行和可测量的极限--常常被添加到这些要求中。",
            "这些应用中的真空阀在以下方面与标准真空阀不同:"],
          children: [
            {
              title: "最小化的颗粒排放",
              text: "高性能真空阀经过优化，不会通过其外壳、机械装置或密封件的材料放出颗粒，也不会通过其开闭或控制运动的摩擦放出颗粒。这是通过对所用材料的特殊选择和处理，以及通过某些设计细节来实现的，这些细节可以最大限度地减少或在某些情况下完全消除粒子的释放。",
            },
            {
              title: "最小化的运动脉冲",
              text: "每一个阀门通过其开启和关闭运动产生运动脉冲。在自动驱动阀门的情况下，这些脉冲的范围可以从轻微的振动到可以听到和感知的硬冲击。这些运动脉冲可能会对敏感的制造工艺产生负面影响，例如，通过额外的颗粒释放。除了设计特点外，高性能真空阀主要通过控制所谓的运动曲线来减少这些脉冲。与乘客电梯的运行方式类似，在到达关闭点前不久，关闭速度会减慢，以防止\"撞击\"。这些运动曲线通常可以被修改，例如，在关闭时间和关闭频率方面，它们可以适应所需条件。",
            },
            {
              title: "中性化学和物理行为",
              text: "真空阀总是改变真空工艺室的均匀性，无论其形式如何。这种情况的发生，部分是由于其几何形状的结果。流动路径的变窄或变宽可以改变流动阻力和流动速度，或者死角，如阀板的移动空间，可以促进沉积过程。这也是通过开启和关闭运动发生的，它改变了流动行为以及工艺气体的浓度、分布、混合和温度。高性能真空阀经过优化，尽可能地补偿这种影响，或使其可控。为此，在设计中加入了各种额外的技术，这些技术远远超出了阀门的基本功能。",
            },
          ]
        },
        {
          title: "真空阀的类型有哪些?",
          text: ["真空阀和其他阀门一样，使用一些基本的力学原理，如闸阀、挡板盘或旋转盘来分离或隔离真空区域并控制体积流量。然而，使用这些力学原理的基本条件是完全不同的。例如，高自由度的颗粒、精确控制非常小的体积流动、密封、最小的振动和冲击是至关重要的特性。因此，这些基本的机械装置通常为真空阀设计得不同。例如，关闭机构通常被设计为无摩擦地关闭，并引起最小的振动和冲击，如果有的话。此外，控制运动可以是极其精细的剂量，密封被优化，以便在理想情况下不释放任何颗粒，其静态或动态特性在长期使用中保持稳定。",
            "使用的真空阀有以下基本类型:", "除了这些基本类型，还有大量的混合变体，其中一些结合了不同的阀门技术或为某些特殊要求提供解决方案。", "您想了解更多吗?", "请与我们联系，期待着与您沟通。"],
          children: [
            {
              title: "<span style='color: #990099'>真空闸阀</span>-通常是隔离或较简单的控制应用的理想选择。安装深度很窄，传导性最大(流阻\n" +
                "最小)，但闸门的行程空间需要。这些也可以采取真空狭缝阀、真空传输阀或真空门的形式，产品通过这些阀门被引入真空工艺室。",
            },
            {
              title: "<span style='color: #990099'>真空角阀</span>-通用的一般用途真空阀。尺寸非常紧凑，通常在密封、执行器和传感器方面非常模块化。平均电导率，非常容易维护。非常好，如果需要的话，有非常精确的可控性。",
            },
            {
              title: "<span style='color: #990099'>真空蝶阀</span>-主要用于控制应用。非常窄的安装深度，良好的传导性，快速和精确的可控性。",
            },
            {
              title: "<span style='color: #990099'>真空摆阀</span>-非常窄的安装深度和紧凑的尺寸，结合非常精确的控制行为，非常好的绝缘能力和非常高的传导性。",
            },
            {
              title: "<span style='color: #990099'>对称流真空调节阀</span>-特殊类型，优化了从第一个开口到整个阀门开口的非常均匀的流动行为。",
            },
            {
              title: "<span style='color: #990099'>气体计量阀或漏气阀</span>-特别是对于非常精细的计量，例如，低流量的工艺气体的计量。",
            },
            {
              title: "<span style='color: #990099'>泄压阀或排气阀</span>-安全阀允许真空系统有控制地，通常是完全通风，并防止超过规定的压力条件。",
            },
            {
              title: "<span style='color: #990099'>真空止回阀</span>-被动式，体积流量和压差操作的阀门。通常用于保护真空系统免受倒流污染。例如，用于真空回流泵和真空系统之间。",
            },
            {
              title: "<span style='color: #990099'>快速闭合阀</span>-主动式保护阀，通常保护较大的真空体积或真空室不因泄漏而造成真空损失。主要特点:对检测到的压力下降有非常快的关闭反应。在UHV和XHV应用中，通常由扇形真空阀(通常是真空闸阀)支持，以确保即使在非常高的压差下也能实现密封隔离。",
            },
            {
              title: "<span style='color: #990099'>真空全金属阀</span>-专为极端压力、温度和辐射条件设计的一组真空阀。主要特点:硬对硬(金属对金属)的密封，而不是弹性密封，因为弹性密封无法承受服务条件。",
            },
            {
              title: "<span style='color: #990099'>真空多阀装置</span>-特殊类型的真空阀，将几种真空阀的功能结合在一个单元中。主要特点:减少部件数量，装配速度快。通常是根据客户要求定制。",
            },
            {
              title: "<span style='color: #990099'>3位真空阀</span>-真空隔离阀的特殊形式，其中除了关闭和打开的位置外，还可以定义第三个阀位。例如，一种应用是为了避免在高压差时由于阀门打开过快而产生的压力脉冲。在第三个位置，密封圈上的接触压力在短时间内略微降低，而阀门却没有明显的打开，从而使压力变化更加平稳。",
            },
          ]
        },
      ]
    } else {
      this.textList = [
        {
          title: "What is a vacuum valve?",
          text:
            "A vacuum valve is a device installed in the supply or exhaust pipeline of a vacuum system. It is usually used to isolate vacuum areas, such as process rooms, or to control the amount of gas entering and exiting. Vacuum valves can be operated manually, pneumatically, electronically, electrically, or electromagnetic. Vacuum valves are a component of any vacuum system, and vacuum systems are widely used in various industrial production applications.",
        },
        {
          title: "What is a high-performance vacuum valve?",
          text: ["Some vacuum processes have particularly high requirements for the purity, chemical and physical stability of the process environment. For example, this applies to almost all semiconductor production fields, as well as many research facilities that use vacuum systems. In the field of basic research, the ability to handle extreme conditions such as extremely high or low temperatures, strong radiation, and extremely high vacuum (XHV) pressures of up to 10-15 mbar - currently technically feasible and measurable limits - is often added to these requirements.",
            "The vacuum valves in these applications differ from standard vacuum valves in the following aspects:"],
          children: [
            {
              title: "Minimizing particulate emissions",
              text: "The high-performance vacuum valve has been optimized to not release particles through its casing, mechanical devices, or sealing materials, nor through its opening and closing or frictional control of motion. This is achieved through special selection and treatment of the materials used, as well as through certain design details that can minimize or, in some cases, completely eliminate particle release.",
            },
            {
              title: "Minimizing motion pulses",
              text: "Each valve generates motion pulses through its opening and closing motion. In the case of automatic valve actuation, the range of these pulses can range from slight vibrations to audible and perceptible hard impacts. These motion pulses may have a negative impact on sensitive manufacturing processes, for example, by releasing additional particles. In addition to design features, high-performance vacuum valves mainly reduce these pulses by controlling the so-called motion curve. Similar to the operation of passenger elevators, the closing speed will slow down shortly before reaching the closing point to prevent \"impact\". These motion curves can usually be modified, for example, in terms of closing time and closing frequency, they can adapt to the required conditions.",
            },
            {
              title: "Neutral Chemistry and Physical Behavior",
              text: "The vacuum valve always changes the uniformity of the vacuum process chamber, regardless of its form. The occurrence of this situation is partly due to its geometric shape. The narrowing or widening of the flow path can change the flow resistance and velocity, or dead corners, such as the movement space of the valve plate, which can promote the sedimentation process. This also occurs through opening and closing movements, which alter flow behavior and the concentration, distribution, mixing, and temperature of process gases. The high-performance vacuum valve has been optimized to compensate for this impact as much as possible or make it controllable. Therefore, various additional technologies have been incorporated into the design, which far exceed the basic functions of the valve.",
            },
          ]
        },
        {
          title: "What are the types of vacuum valves?",
          text: ["Vacuum valves, like other valves, use some basic mechanical principles such as gate valves, baffle discs, or rotating discs to separate or isolate the vacuum area and control the volumetric flow rate. However, the basic conditions for using these mechanical principles are completely different. For example, high degree of freedom particles, precise control of very small volume flow, sealing, minimal vibration and impact are crucial characteristics. Therefore, these basic mechanical devices are usually designed differently for vacuum valves. For example, the closing mechanism is usually designed to close without friction and cause minimal vibration and impact, if any. In addition, controlling motion can be extremely precise in dosage, with optimized sealing to ensure that no particles are released under ideal conditions, and its static or dynamic characteristics remain stable during long-term use.",
            "The basic types of vacuum valves used are as follows:", "In addition to these basic types, there are also a large number of hybrid variants, some of which combine different valve technologies or provide solutions for certain special requirements.", "Do you want to learn more?", "Please contact us and look forward to communicating with you。"],
          children: [
            {
              title: "<span style='color: #990099'>Vacuum gate valve</span>-Usually an ideal choice for isolation or simpler control applications. The installation depth is very narrow, with the highest conductivity (minimum flow resistance), but the travel space of the gate needs to be limited. These can also take the form of vacuum slit valves, vacuum transfer valves, or vacuum doors, through which products are introduced into the vacuum process chamber.",
            },
            {
              title: "<span style='color: #990099'>Vacuum angle valve</span>-Universal general-purpose vacuum valve. The size is very compact, usually very modular in terms of sealing, actuators, and sensors. The average conductivity is very easy to maintain. Very good, if necessary, with very precise controllability.",
            },
            {
              title: "<span style='color: #990099'>Vacuum butterfly valve</span>-Mainly used for controlling applications. Very narrow installation depth, good conductivity, fast and precise controllability.",
            },
            {
              title: "<span style='color: #990099'>Vacuum swing valve</span>-Very narrow installation depth and compact size, combined with very precise control behavior, excellent insulation ability and very high conductivity.",
            },
            {
              title: "<span style='color: #990099'>Symmetric flow vacuum regulating valve</span>-Special type, optimized for very uniform flow behavior from the first opening to the entire valve opening.",
            },
            {
              title: "<span style='color: #990099'>Gas metering valve or leakage valve</span>-Especially for very precise measurements, such as the measurement of low flow process gases.",
            },
            {
              title: "<span style='color: #990099'>Pressure relief valve or exhaust valve</span>-The safety valve allows the vacuum system to be controlled, usually fully ventilated, and prevents exceeding specified pressure conditions.",
            },
            {
              title: "<span style='color: #990099'>Vacuum check valve</span>-Passive, volume flow and pressure differential operated valves. Usually used to protect vacuum systems from backflow pollution. For example, used between vacuum reflux pumps and vacuum systems.",
            },
            {
              title: "<span style='color: #990099'>Quick closing valve</span>-Active protection valves typically protect large vacuum volumes or chambers from vacuum loss caused by leakage. Main feature: It has a very fast closing response to detected pressure drops. In UHV and XHV applications, it is usually supported by fan-shaped vacuum valves (usually vacuum gate valves) to ensure sealing isolation even at very high pressure differentials.",
            },
            {
              title: "<span style='color: #990099'>Vacuum all metal valve</span>-A set of vacuum valves designed specifically for extreme pressure, temperature, and radiation conditions. Main features: Hard to hard (metal to metal) sealing instead of elastic sealing, as elastic sealing cannot withstand service conditions.",
            },
            {
              title: "<span style='color: #990099'>Vacuum multi valve device</span>-A special type of vacuum valve that combines the functions of several vacuum valves into one unit. Main features: reducing the number of components and fast assembly speed. Usually customized according to customer requirements.",
            },
            {
              title: "<span style='color: #990099'>3 position vacuum valve</span>-A special form of vacuum isolation valve, in which a third valve position can be defined in addition to the closed and open positions. For example, one application is to avoid pressure pulses caused by valve opening too quickly during high pressure differential. In the third position, the contact pressure on the sealing ring slightly decreases in a short period of time, while the valve does not open significantly, making the pressure change more stable.",
            },
          ]
        },
      ]
    }
  },
  computed: {
    imageSrc() {
      // 从i18n获取baseUrl，并拼接图片名称
      return this.$t('i18n.bannerBg2');
    }
  },
  mounted() {
    this.goTop();
    let _that = this;
    _that.swiper = new Swiper(".pro-swiper", {
      loop: true,
      slidesPerView: this.isMobile() ? 1 :3,
      loopedSlides: this.isMobile() ? 1 : 3,
      spaceBetween: 130, // 每个滑块之间的间距为30px
      speed:2500,
      freeMode: true,
      //自动播放
      autoplay: {
        delay: 100,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        waitForTransition:true
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
  },

  methods: {
    toPage(item) {
      if ("/" + item.path === this.$route.path) {
        return;
      }
      let params = [];
      this.list.forEach(t => {
        let data = Object.assign({}, t);
        if (t.path === item.path) {
          data.isShow = true;
          data.pathName = this.$t('i18n.headerMain.vacuumValve')
          data.lastPathName = this.$t('i18n.headerMainChildren.' + t.name)
        }
        params.push(data);
      });

      this.$router.push({
        name: item.path,
        params: { list: params }
      })
    },
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    showText(item) {
      this.$set(item, "show", !item.show);
      console.log(item)
    },
    show(item) {
      if (item.show) {
        this.classS.display = 'block'
        return this.classS;
      }
    },
    changeLine(str){
      return str.replace(/<br>/g,'\n')
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // document.querySelector('#topDom').scrollIntoView({
      //   behavior: 'smooth'
      // })
    },
  },
}
</script>

<style scoped>
.container-fluid {
  max-width: 145rem;
}
.breadcrumb {
  display: flex;
  height: 8rem;
  align-items: center;
  position: absolute;
  z-index: 80;
  left: 5rem;
  margin: 0;
  padding: 0;
}
.breadcrumb__li {
  position: relative;
  padding-right: 2.5rem;
  margin-right: 2rem;
}
.breadcrumb__link {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #e3e3e3;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.breadcrumb__li.--current:after {
  content: "";
  width: 0.6rem;
  height: 1rem;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -0.3rem;
  background: url(../assets/imgs/arrow-breadcrumb.svg) no-repeat 50%;
}
.breadcrumb__li:last-child {
  padding-right: 0;
  margin-right: 0;
}
.breadcrumb__text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #FFFFFF;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.banner {
  position: relative;
  width: 100%;
  height: 61rem;
  align-items: center;
  display: flex;
  background-image: url(../assets/imgs/zhenkongBg.png);
  background-size: cover; /* 保证背景图片覆盖元素并且不变形 */
  background-position: center; /* 将背景图片居中显示 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  padding: 10rem 0 0 0;
  flex-direction: column;
}
.banner__bg {
  /* position: absolute;
  width: 100%;
  height: 61rem; */
  position: absolute;
  bottom: 0;
  margin-top: 1rem;
}
.banner__bg {
  z-index: 1;
}
.banner__bg img {
  /* max-width: 100%; */

  display: block;
  width: 100%;
  /* height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%; */
}
.banner__content {
  position: relative;
  z-index: 2;
}
.banner__title {
  font-weight: 500;
  font-size: 4rem;
  color: #fff;
  letter-spacing: -.084rem;
  line-height: 6rem;
  margin-bottom: 25rem;
  margin-left: 15rem;
}
img {
  max-width: 100%;
}

#swiper-pro {
  height: 100%;
  padding-top: 15rem;
  padding-bottom: 15rem;
}
#swiper-pro .pro-swiper .swiper-content{
  border: 1px solid lightgray;
  border-radius: 3%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36rem;
  width: 36rem;
  background: white;
}

#swiper-pro .pro-swiper .swiper-content:hover .swiper-pro-bottom .swiper-pro-text{
  color: #990099;
}
#swiper-pro .pro-swiper  .swiper-content-select:hover {
  background-image: url("../assets/imgs/btnBackground.png") ;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
.swiper-pro-btn {
  display: none;
}

#swiper-pro .pro-swiper  .swiper-content-select:hover .swiper-pro-btn {
  border: 0;
  box-shadow: 0 .2rem .4rem 0 rgba(0,0,0,.05);
  background: #fff;
  font-weight: 300;
  font-size: 1.2rem;
  color: #66207F;
  letter-spacing: -.02rem;
  display: flex;
  width: 80%;
  align-items: center;
  height: 4rem;
  position: relative;
  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.4rem;
  transition: all .2s ease-in-out;
  margin-left: 10%;
}


#swiper-pro .pro-swiper .swiper-content .swiper-pro-img{
  height:  276px;
  width: 210px;
}

#swiper-pro .pro-swiper .swiper-content .swiper-pro-bottom{
  text-align: center; /* 水平居中 */
  position: relative;
  height:  276px;
  width: 210px;
}
#swiper-pro .pro-swiper .swiper-content .swiper-pro-bottom .swiper-pro-text{
  color: black;
  padding-bottom: 1rem;
}

#swiper-pro .swiper-pro-btn:after{
  content: "";
  width: 1rem;
  height: 1rem;
  position: absolute;
  right: 3rem;
  top: 50%;
  margin-top: -0.5rem;
  background: #6C2188;
  -webkit-mask: url(../assets/imgs/arrow-right.png) no-repeat center;
  mask: url(../assets/imgs/arrow-right.png) no-repeat center;
  transition: all .2s ease-in-out;
}
#swiper-pro .pro-swiper .swiper-content .swiper-pro-img img {
  display: block; /* 去除图片下方默认间距 */
  margin: 0 auto; /* 水平居中 */
  max-width: 100%;
  max-height: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* 垂直居中 */
}

.pro-swiper-prev {
  background-image: url("../assets/imgs/proSwiperLeft.png");
  background-size: 16px 28px;
}
.pro-swiper-next {
  background-image: url("../assets/imgs/proSwiperRight.png");
  background-size: 16px 28px;
}
.outSwiperBox {
  position: relative;
  padding: 0 4rem;
}

.inSwiperBox{
  height: 100%;
  position: initial;
}

.g-block-wrapper {
  margin: 4rem 0;
}
.accordion-item, .mc-accordion__item {
  border-bottom: .1rem solid #e6e6e6;
}
.accordion-title, .mc-accordion__trigger {
  height: 8rem;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 2rem;
  color: #000;
  letter-spacing: -.02rem;
  line-height: 3rem;
  padding: 0 5rem;
  cursor: pointer;
  position: relative;
  transition: all .2s ease-in-out;
}

.accordion-title:before, .mc-accordion__trigger:before {
  content: "";
  position: absolute;
  z-index: 2;
  left: 2rem;
  top: 50%;
  width: 1rem;
  height: 1rem;
  margin-top: -.4rem;
  background: transparent;
  border: .2rem solid #6C2188;
  box-sizing: border-box;
  border-radius: .3rem;
}
.accordion-title:after, .mc-accordion__trigger:after {
  content: "";
  width: 1rem;
  height: .6rem;
  top: 50%;
  position: absolute;
  z-index: 2;
  right: 2rem;
  margin-top: -.3rem;
  background: url(../assets/imgs/select-arrow.png) no-repeat 50%;
}
.accordion-content, .mc-accordion__content-inner {
  font-size: 2rem;
  color: #4c4c4c;
  letter-spacing: -.02rem;
  line-height: 3rem;
}
.accordion-content {
  padding: 1rem 0 3rem 5rem;
  display: none;
  font-size: 1.6rem;
  font-weight: 500;
}
.show-text {
  display: block;
}
.accordion-content ul li {
  padding-left: 3rem;
  position: relative;
  /* font-size: 2rem; */
  font-size: 1.6rem;
  color: #4c4c4c;
  letter-spacing: -.02rem;
  line-height: 3rem;
  margin-bottom: 1rem;
}
.accordion-content ul li:before {
  content: "";
  position: absolute;
  z-index: 2;
  left: 0;
  top: 1.2rem;
  width: .7rem;
  height: .7rem;
  background: #990099;
  border: .2rem solid #990099;
  box-sizing: border-box;
  border-radius: .2rem;
}

/* 媒体查询，针对最大宽度为768像素的设备 */
@media (max-width: 768px) {
  .breadcrumb {
    top: 14rem;
  }
  .banner__bg{
    margin: 0;
  }
  .banner {
    /* margin-top: -110px; */
    padding-top: 0rem;
    width: 100%;
    background-image: none !important;
    overflow:hidden;
  }
  .mobileBg {
    display: block;
    width: 100%;
    height: auto;
  } 
  #swiper-pro .pro-swiper .swiper-content{
    height: 36rem;
    width: 32rem;
  }
}
@media (max-width: 414px) {
  #swiper-pro .pro-swiper .swiper-content{
    height: 36rem;
    width: 29rem;
  }
}
@media (max-width: 390px) {
  #swiper-pro .pro-swiper .swiper-content{
    height: 36rem;
    width: 28rem;
  }
}
@media (max-width: 375px) {
  #swiper-pro .pro-swiper .swiper-content{
    height: 36rem;
    width: 26.5rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/VacuumValveMain.vue